// extracted by mini-css-extract-plugin
module.exports = {"tag":"styles_tag__sh1mP","scrollbars":"styles_scrollbars__e0iGe","slideInSearchBar":"styles_slideInSearchBar__xtCJj"};